(function () {
  function contextFor(root) {
    var collection = root ? root.closest('.collection-redesign--bundles') : null;
    var filterKind = root && root.dataset.bundleFilterKind === 'vibe' ? 'vibe' : 'pieces';
    return {
      collection: collection,
      filterKind: filterKind,
      cards: collection ? Array.prototype.slice.call(collection.querySelectorAll(filterKind === 'vibe' ? '[data-bundle-vibes]' : '[data-bundle-piece-count]')) : [],
      buttons: root ? Array.prototype.slice.call(root.querySelectorAll('[data-bundle-filter]')) : [],
      resultCount: collection ? collection.querySelector('[data-bundle-result-count]') : null,
      viewToggle: collection ? collection.querySelector('[data-bundle-view-toggle]') : null
    };
  }

  function normalizeFilter(buttons, value) {
    return buttons.some(function (button) {
      return button.dataset.bundleFilter === value;
    }) ? value : 'all';
  }

  function applyFilter(root, requestedFilter) {
    var context = contextFor(root);
    if (!context.cards.length || !context.buttons.length || !context.resultCount) return null;

    var filter = normalizeFilter(context.buttons, requestedFilter);
    var visibleCount = 0;

    context.cards.forEach(function (card) {
      var cardFilters = context.filterKind === 'vibe'
        ? (card.dataset.bundleVibes || '').split(/\s+/)
        : [card.dataset.bundlePieceCount];
      var visible = filter === 'all' || cardFilters.indexOf(filter) !== -1;
      card.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    context.buttons.forEach(function (button) {
      var active = button.dataset.bundleFilter === filter;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    context.resultCount.textContent = visibleCount;
    return filter;
  }

  function normalizeView(value) {
    return value === 'compare' ? 'compare' : 'default';
  }

  function applyView(collection, requestedView) {
    if (!collection) return null;

    var view = normalizeView(requestedView);
    var compare = view === 'compare';
    var toggle = collection.querySelector('[data-bundle-view-toggle]');

    collection.classList.toggle('collection-redesign--compare', compare);
    if (toggle) toggle.setAttribute('aria-pressed', compare ? 'true' : 'false');

    collection.querySelectorAll('.cr-card__image-stage').forEach(function (stage) {
      stage.setAttribute('aria-hidden', compare ? 'true' : 'false');
    });
    collection.querySelectorAll('.cr-card__compare-stage').forEach(function (stage) {
      stage.setAttribute('aria-hidden', compare ? 'false' : 'true');
    });

    return view;
  }

  function filterParameter(root) {
    return root && root.dataset.bundleFilterKind === 'vibe' ? 'vibe' : 'pieces';
  }

  function filterFromUrl(root) {
    return new URL(window.location.href).searchParams.get(filterParameter(root)) || 'all';
  }

  function viewFromUrl() {
    var value = new URL(window.location.href).searchParams.get('compare');
    if (value === '1') return 'compare';
    return value || 'default';
  }

  function writeUrl(root, filter, replace) {
    var url = new URL(window.location.href);
    var parameter = filterParameter(root);
    if (filter === 'all') {
      url.searchParams.delete(parameter);
    } else {
      url.searchParams.set(parameter, filter);
    }
    url.searchParams.delete(parameter === 'vibe' ? 'pieces' : 'vibe');
    url.searchParams.delete('palette');

    var method = replace ? 'replaceState' : 'pushState';
    window.history[method]({ bundleFilter: filter }, '', url.pathname + url.search + url.hash);
  }

  function writeViewUrl(view, replace) {
    var url = new URL(window.location.href);
    if (view === 'compare') {
      url.searchParams.set('compare', '1');
    } else {
      url.searchParams.delete('compare');
    }

    var method = replace ? 'replaceState' : 'pushState';
    window.history[method]({ bundleView: view }, '', url.pathname + url.search + url.hash);
  }

  function initializeFinder(root) {
    var requestedFilter = filterFromUrl(root);
    var appliedFilter = applyFilter(root, requestedFilter);
    var hasOldPaletteFilter = new URL(window.location.href).searchParams.has('palette');
    if (appliedFilter && (appliedFilter !== requestedFilter || hasOldPaletteFilter)) writeUrl(root, appliedFilter, true);

    var context = contextFor(root);
    var requestedView = viewFromUrl();
    var appliedView = applyView(context.collection, requestedView);
    if (appliedView && appliedView !== requestedView) writeViewUrl(appliedView, true);
  }

  function initializeAll() {
    document.querySelectorAll('[data-bundle-finder]').forEach(initializeFinder);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var viewToggle = target && target.closest ? target.closest('[data-bundle-view-toggle]') : null;
    if (viewToggle) {
      var collection = viewToggle.closest('.collection-redesign--bundles');
      if (!collection) return;

      var requestedView = viewToggle.getAttribute('aria-pressed') === 'true' ? 'default' : 'compare';
      var appliedView = applyView(collection, requestedView);
      if (appliedView) writeViewUrl(appliedView, false);
      return;
    }

    var button = target && target.closest ? target.closest('[data-bundle-filter]') : null;
    if (!button) return;

    var root = button.closest('[data-bundle-finder]');
    if (!root) return;

    var requestedFilter = button.dataset.bundleFilter;
    var currentFilter = filterFromUrl(root);
    var appliedFilter = applyFilter(root, requestedFilter);
    if (appliedFilter && appliedFilter !== currentFilter) writeUrl(root, appliedFilter, false);
  });

  window.addEventListener('popstate', function () {
    document.querySelectorAll('[data-bundle-finder]').forEach(function (root) {
      var requestedFilter = filterFromUrl(root);
      var appliedFilter = applyFilter(root, requestedFilter);
      if (appliedFilter && appliedFilter !== requestedFilter) writeUrl(root, appliedFilter, true);

      var context = contextFor(root);
      var requestedView = viewFromUrl();
      var appliedView = applyView(context.collection, requestedView);
      if (appliedView && appliedView !== requestedView) writeViewUrl(appliedView, true);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
